/**
 * EraserIcon - a simple flat-illustration icon for a rubber eraser.
 * The default emoji rendered here previously read as a bar of soap, which was
 * misleading. This SVG keeps the same friendly, colorful flat style as the
 * other item icons (backpack, pencil, ruler, sharpener) used across the
 * volunteer guide.
 */
export default function EraserIcon({ className = "" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-label="Eraser"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Angled eraser body */}
      <g transform="rotate(-32 32 32)">
        {/* pink rubber lower portion */}
        <rect x="16" y="24" width="32" height="22" rx="4" fill="#EC6A5E" />
        <rect x="16" y="24" width="32" height="6" rx="4" fill="#F28B80" />
        {/* blue paper sleeve */}
        <rect x="16" y="30" width="32" height="10" fill="#3E7CB1" />
        <rect x="16" y="30" width="32" height="3" fill="#5B9BD1" />
        {/* subtle worn tip highlight */}
        <path d="M16 40 L16 46 Q16 46 20 46 L20 40 Z" fill="#D2564B" />
      </g>
    </svg>
  );
}
